import {
  FIELD_YOUTUBE_VIDEO_DURATION_INVALID,
  FIELD_YOUTUBE_VIDEO_NOT_PUBLIC,
} from "../i18n/keysTranslations";

export const getYoutubeVideoValidationErrorMessage = ({
  isPublic,
  isDurationValid,
  t,
}) => {
  if (!isPublic) {
    return t(FIELD_YOUTUBE_VIDEO_NOT_PUBLIC);
  }

  if (!isDurationValid) {
    return t(FIELD_YOUTUBE_VIDEO_DURATION_INVALID);
  }

  return undefined;
};

export const getYoutubeVideoAddValidationResult = ({
  isPublic,
  isDurationValid,
  t,
}) => {
  if (!isPublic) {
    return {
      shouldBlockOnInput: true,
      errorMessage: t(FIELD_YOUTUBE_VIDEO_NOT_PUBLIC),
    };
  }

  if (!isDurationValid) {
    return {
      shouldBlockOnInput: true,
      errorMessage: t(FIELD_YOUTUBE_VIDEO_DURATION_INVALID),
    };
  }

  return { shouldBlockOnInput: false };
};

export const findInvalidYoutubeUrlEntry = ({ invalidUrls, url }) => {
  const normalizedUrl = url.trim();

  return invalidUrls.find(
    (invalidUrl) => invalidUrl.url?.trim() === normalizedUrl
  );
};
